import React from 'react';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';
import Sectorization from './Sectorization';

const SectorizationWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'Setorização',
            }}
        >
            <Sectorization />
        </ServicesChartsDataProvider>
    );
};

export default SectorizationWrapper;
